import React, { useContext, useEffect } from "react"
import { FeatureCatalogContext } from "../../FeatureCatalogProvider"
import Inheritance from "./components/Inheritance/Inheritance"
import Properties from "./components/Properties/Properties"
import Attributes from "./components/Attributes/AttributeTypeTreeItem"
import "./panel.scss"
import Affiliation from "./components/Affiliation/Affiliation"
import { Toast } from "react-bootstrap"
import featureTypeIcon from "../../Assets/Icons/featureType.svg"
import attributeTypeIcon from "../../Assets/Icons/attributeType.svg"
import featureTypeGroupIcon from "../../Assets/Icons/featureTypeGroup.svg"
import { useHistory, useLocation, useParams } from "react-router-dom"
import { GetApi } from "../../../../api/api"
import AttributeProperties from "./components/AttributeProperties/AttributeProperties"
import useQuery from "../UseQuery"

const Panel = () => {
  const context = useContext(FeatureCatalogContext)
  const history = useHistory()
  const { catalog, type, pid } = useParams<{ catalog: string; type: string; pid: string }>()
  const language = useQuery().get("language")
  const { search } = useLocation()

  useEffect(() => {
    const checkIfTypeIsInHistory = () => {
      // This function helps catching when an attributetype is pushed to the history when page is refreshed.
      // Attributetypes is handled differently than featuretypes or featuretypegroups.
      if (type === "attributeType") {
        context.setAtId(parseInt(pid, 10))
      }
    }
    checkIfTypeIsInHistory()
  }, [])

  useEffect(() => {
    const getProps = async () => {
      if (!type || !pid) {
        return
      }
      context.setLoading(true)
      const api = await GetApi()
      if (type === "featureTypeGroup") {
        const res = await api.getAnyFeatureTypeGroup(catalog, parseInt(pid, 10), language)
        context.setElementDetails(res)
        context.setTypeDisplayName(res.name)
      }
      if (type === "featureType") {
        const res = await api.getAnyFeatureType(catalog, parseInt(pid, 10), true, language)
        context.setElementDetails(res)
        context.setTypeDisplayName(res.name)
      }
      context.setLoading(false)
    }

    getProps()
  }, [pid, language])

  const onClick = () => {
    context.setAtId(null)
    context.setTypeDisplayName("")
    const address = `/featurecatalogdetails/${catalog}`
    history.push({ pathname: address, state: catalog, search: "?" + new URLSearchParams(search)})
  }

  if (pid) {
    return (
      <div className="panelDiv">
        <Toast className="lead-text" id="toast" role="alert">
          <Toast.Header className="lead-text" closeButton={false}>
            <div className="pr-3">
              {type === "attributeType" ? (
                <img src={attributeTypeIcon} />
              ) : type === "featureTypeGroup" ? (
                <img src={featureTypeGroupIcon} />
              ) : (
                <img src={featureTypeIcon} />
              )}
              <span className="nameString">{context.typeDisplayName} </span>
            </div>
          </Toast.Header>
          <Toast.Body>
            <button type="button" className="close" onClick={onClick} data-dismiss="toast">
              <i className="modus-icons">close</i>
            </button>
          </Toast.Body>
        </Toast>
        <div className="divider">
          <div className="leftCol">
            {type === "featureType" && <Attributes />}
            {type === "featureTypeGroup" && (
              <>
                <Properties />
                <hr />
              </>
            )}
            {type === "attributeType" && (
              <>
                <AttributeProperties />
                <hr />
              </>
            )}
          </div>
          <p />
          <div className="rightCol">
            {type === "featureType" && (
              <>
                <Properties />
                <hr />
                <Affiliation />
                <hr />
                <Inheritance />
              </>
            )}
          </div>
        </div>
      </div>
    )
  } else {
    return <></>
  }
}

export default Panel
